import { Form, FormItemProps, Input } from 'antd';
import { FC } from 'react';

import './styles.scss';

interface FormItemInputPropsType extends FormItemProps {
  label: React.ReactNode;
  description?: string;
  name: string;
  value?: string;
}

const FormItemInput: FC<FormItemInputPropsType> = (props) => {
  const { label, description, name } = props;

  return (
    <Form.Item
      {...props}
      name={name}
      tooltip={description}
      className="form__item-input"
      label={
        <div className="item-number__label">
          <span>{label}</span>
        </div>
      }
    >
      <Input />
    </Form.Item>
  );
};

export default FormItemInput;
